module.exports = __webpack_public_path__ + "static/img/6.813720b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/7/1/sp/6.png
// module id = 6RCS
// module chunks = 0